const { useState, useEffect } = require("react");

const useApiHook = (fetchFunction, autoFetch = true) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetchFunction();
      setData(response.data);
    } catch (err) {
      setError(err.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  const resetData = () => {
    setData(null);
    setError(null);
  };

  const refetch = () => {
    resetData();
    fetchData();
  };

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (autoFetch) {
        fetchData();
      }
    }, 50);
    return () => clearTimeout(timeout);
  }, []);

  return {
    data,
    loading,
    error,
    refetch,
    resetData,
  };
};

export default useApiHook;
